import React, { useState } from "react";
import Modal from "react-modal";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { convertStraight, formattedLongDate } from "../../common-data/Converts";
import InitiatedJobs from "./InitiatedJobs";

const JobLogs = ({
  userInfoData,
  isLoading,
  tbDatas,
  isPage,
  setIsPage,
  callFunction,
}) => {
  const iniModValues = {
    isModalOpen: false,
    cardType: "",
    rowData: {},
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const tbColumns = [
    {
      dataField: "campaign_id",
      text: "campaign",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.campaign_name?.replace(/_/g, " ") || "NA"} <br />
            <small className="gray underline text-initial">
              {row?.campaign_id || "-"} <br />
            </small>
          </span>
        );
      },
    },
    {
      dataField: "job_name",
      text: "JOB name/ID",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.job_name?.replace(/_/g, " ") || "NA"}
            <br />
            <small className="gray underline text-initial">
              {row?.job_id || "-"}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "total_initiated",
      text: "Total OBD Call initiated",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link minWidth80"
            style={{
              fontWeight: "bold",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModalOpen: true,
                cardType: "initiated_call_details",
                rowData: row,
              }));
            }}
          >
            {row?.total_initiated || 0}
          </span>
        );
      },
    },
    {
      dataField: "job_state",
      text: "JOB Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 bold"
            style={{
              background:
                row?.job_state === "completed"
                  ? "#E2EFD5"
                  : row?.job_state === "running"
                  ? "#E0F4FF"
                  : "#F0E3E3",
              color:
                row?.job_state === "completed"
                  ? "#379C00"
                  : row?.job_state === "running"
                  ? "#39A7FF"
                  : "#F13434",
              borderRadius: "10px",
              fontWeight: "500",
            }}
          >
            {row?.job_state?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "parent_id_name",
      text: "Parent",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.parent_id_name?.replace(/_/g, " ") || "-"} <br />
            <small className="gray underline text-initial">
              {row?.parent_id || ""} <br />
            </small>
          </span>
        );
      },
    },
    {
      dataField: "root_id_name",
      text: "Root",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.root_id_name?.replace(/_/g, " ") || "-"} <br />
            <small className="gray underline text-initial">
              {row?.root_id || ""} <br />
            </small>
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formattedLongDate(row.date_added) : "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "start_date",
    //   text: "Start Date",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         {row?.start_date ? convertStraight(row.start_date) : "-"}
    //       </span>
    //     );
    //   },
    // },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer mod-height-95vh`}>
          <ModalHeadAndClose
            title={modValues.cardType?.replace(/_/g, " ")}
            onClose={closeModal}
          />

          <InitiatedJobs
            userInfoData={userInfoData}
            rowData={modValues.rowData}
            callFunction={callFunction}
            closeInitiateModal={closeModal}
          />
        </div>
      </Modal>

      {isLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <>
          <div className="overflowAuto separatedTable mt30">
            <PaymentLinkTable
              tableData={tbDatas.allData}
              tableColumns={tbColumns}
              tablePagination={tbDatas.pagination}
              isPage={isPage}
              setIsPage={setIsPage}
            />
          </div>
        </>
      )}
    </>
  );
};

export default JobLogs;
